import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { LoginState } from 'global/LoginState'

function PrivateRoute({ children, roles = [] }) {
  const { isLoggedIn, role } = useRecoilValue(LoginState)
  const location = useLocation()

  // Redirect to login if the user is not logged in
  if (!isLoggedIn) {
    return <Navigate to="/" state={{ from: location }} replace />
  }

  // Restrict route access based on role
  if (roles.length && !roles.includes(role)) {
    return <Navigate to="/unauthorized" replace />
  }

  return children
}

export default PrivateRoute
